import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const initialCreativeApprovalsState = {
	isLoaded: false,
	hasErrorLoading: false,
};

const CREATIVE_APPROVALS_ACTIONS = {
	FETCH_APPROVAL_HISTORY_AJAX: "FETCH_APPROVAL_HISTORY_AJAX",
	FETCH_APPROVAL_HISTORY_SUCCESS: "FETCH_APPROVAL_HISTORY_SUCCESS",
	FETCH_APPROVAL_HISTORY_ERROR: "FETCH_APPROVAL_HISTORY_ERROR",
};

export const handlers = {
	[CREATIVE_APPROVALS_ACTIONS.FETCH_APPROVAL_HISTORY_AJAX]: getApprovalHistory,
	[CREATIVE_APPROVALS_ACTIONS.FETCH_APPROVAL_HISTORY_SUCCESS]: successApprovalHistory,
	[CREATIVE_APPROVALS_ACTIONS.FETCH_APPROVAL_HISTORY_ERROR]: errorApprovalHistory,
};

let reducerConfig = {
	typeRoot: "CREATIVE_APPROVALS",
	actionTypes: CREATIVE_APPROVALS_ACTIONS,
	actionCreators: {
		fetchApprovalHistory,
	},
	initialState: initialCreativeApprovalsState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "dateCreated:DESC" });
reducerConfig = addColumnFilters(reducerConfig, {}); /*
	We're not actually using any column filters here, but this enables us to use the useCollectionFiltering hook,
	which simplifies fetching when filtering params change.*/

export function fetchApprovalHistory(libraryId, creativeIds) {
	return ((dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.creativeApprovals;
		return dispatch({
			type: CREATIVE_APPROVALS_ACTIONS.FETCH_APPROVAL_HISTORY_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives/${creativeIds}/approval-history-paginated`,
				success: CREATIVE_APPROVALS_ACTIONS.FETCH_APPROVAL_HISTORY_SUCCESS,
				error: CREATIVE_APPROVALS_ACTIONS.FETCH_APPROVAL_HISTORY_ERROR,
				params: filterInfo,
			},
		});
	});
}

export function getApprovalHistory(state, action) {
	return {
		...state,
		items: [],
		isLoaded: false,
		hasErrorLoading: false,
	};
}

export function successApprovalHistory(state, action) {
	let { data } = action.payload;

	return {
		...state,
		...data,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

export function errorApprovalHistory(state, action) {
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: true,
	};
}


export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const CreativeApprovals = reducerConfig.actionCreators;
